export var IconSource;
(function (IconSource) {
  IconSource["BoschFontIcons"] = "BoschFontIcons";
  IconSource["PauBbgFontIcons"] = "PauBbgFontIcons";
  IconSource["BoschUiIcons"] = "BoschUiIcons";
})(IconSource || (IconSource = {}));
